import '@cognitoforms/styles/global/notifications.scss';
import { Message } from '@cognitoforms/element-ui';
import Inline from '../components/content/Inline.vue';
import Vue from 'vue';

export default (message, type = 'info', duration = null, showClose = true, customIcon = null) => {
	let icon;
	let iconComponent;
	if (type === 'success')
		icon = 'success';
	else if (type === 'error' || type === 'warning')
		icon = 'warning';
	else if (type === 'custom')
		icon = customIcon;
	else
		icon = null;

	if (icon)
		iconComponent = new Vue({
			props: Object.keys(Inline.props),
			propsData: {
				svg: icon
			},
			template: '<inline class="sz-6 text-icon-subtle" ref="component" v-bind="$props" />'
		});

	// changed this I think it makes more sense to go by the words b/c thats how reading speeds are quantified
	// I googled it it says that the average is 200 words per 2 minutes 120/200 = .6s per word
	// the 400 is the about double the average response time (250ms)
	if (typeof message === 'string') {
		duration = duration === null ? Math.max(3000, message.split(' ').length * 500 + 400) : duration;
		message = `${iconComponent ? `<span id="icon-slot" ></span> ${message}` : message}`;
	}

	Message({
		dangerouslyUseHTMLString: true,
		message: message,
		type: type,
		duration: duration,
		customClass: `notification ${type !== 'info' ? `is-${type} notification--icon` : 'notification--info'}`,
		showClose: showClose
	});

	if (iconComponent)
		iconComponent.$mount('#icon-slot');
};